import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "app-error-dialog",
  class: "w3-modal ppa-ajax-error"
}
const _hoisted_2 = { class: "w3-modal-content w3-card" }
const _hoisted_3 = { class: "w3-container w3-theme" }
const _hoisted_4 = { class: "w3-container w3-theme-l5" }

import { library } from "@fortawesome/fontawesome-svg-core";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { storeToRefs } from 'pinia';
import { useErrorStore } from "../stores/error.store";


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorRender',
  setup(__props) {

library.add(faExclamationTriangle);

const errorStore = useErrorStore();

const { errorMessage } = storeToRefs(errorStore);

function dismissError(): void {
  errorStore.clearErrorMessage();
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_unref(errorMessage))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("header", _hoisted_3, [
            _createElementVNode("h2", null, [
              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'exclamation-triangle'] }),
              _createTextVNode("Error ")
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", null, _toDisplayString(_unref(errorMessage)), 1)
          ]),
          _createElementVNode("footer", { class: "w3-bar w3-theme w3-padding" }, [
            _createElementVNode("div", { class: "w3-right" }, [
              _createElementVNode("a", {
                class: "w3-bar-item w3-button w3-theme-l5",
                onClick: dismissError
              }, "Ok")
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})